// extracted by mini-css-extract-plugin
export default {"heading":"Disclaimer_heading__kylEF","body":"Disclaimer_body__WCWSQ"};